export default __webpack_public_path__ + "static/favicon-8d7837714142ca9b362c80c326a236cc.ico";